import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { TripProvider } from "./context/TripContext";

function IcpFooter() {
  return (
    <footer className="px-4 pb-24 pt-4 text-center text-[11px] leading-5 text-text-muted">
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center justify-center text-text-muted underline-offset-2 hover:text-bamboo hover:underline"
      >
        浙ICP备2026041470号-1
      </a>
    </footer>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <TripProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
          <IcpFooter />
        </BrowserRouter>
      </TripProvider>
    </I18nextProvider>
  );
}

export default App;
